// extracted by mini-css-extract-plugin
module.exports = {"root":"UserModal_root__1j6vE","details":"UserModal_details__3bJkA","name":"UserModal_name__3IGKz","label":"UserModal_label__3lAxK","edit":"UserModal_edit__k6nxE"};